import AboutToLoseAccountIcon from 'components/HotelStatusIcon/AboutToLoseAccountIcon'
import BasicAccountIcon from 'components/HotelStatusIcon/BasicAccountIcon'
import ChurnedAccountIcon from 'components/HotelStatusIcon/ChurnedAccountIcon'
import LargeAccountIcon from 'components/HotelStatusIcon/LargeAccountIcon'
import MediumAccountIcon from 'components/HotelStatusIcon/MediumAccountIcon'
import PendingIcon from 'components/HotelStatusIcon/PendingIcon'
import {
  hotelCampaignRegistrationStatuses,
  hotelStatuses,
  hotelStatusNames
} from 'main/hotelStatuses'

const HotelStatusIcon = ({ status }) => {
  if (hotelCampaignRegistrationStatuses.includes(status)) {
    return (
      <div title={hotelStatusNames[status]}>
        <PendingIcon />
      </div>
    )
  }

  if (status === hotelStatuses.BasicAccount) {
    return (
      <div title={hotelStatusNames[status]}>
        <BasicAccountIcon />
      </div>
    )
  }

  if (status === hotelStatuses.MediumAccount) {
    return (
      <div title={hotelStatusNames[status]}>
        <MediumAccountIcon />
      </div>
    )
  }

  if (status === hotelStatuses.LargeAccount) {
    return (
      <div title={hotelStatusNames[status]}>
        <LargeAccountIcon />
      </div>
    )
  }

  if (status === hotelStatuses.Churned) {
    return (
      <div title={hotelStatusNames[status]}>
        <ChurnedAccountIcon />
      </div>
    )
  }

  if (status === hotelStatuses.AboutToLose) {
    return (
      <div title={hotelStatusNames[status]}>
        <AboutToLoseAccountIcon />
      </div>
    )
  }

  return (
    <div title={hotelStatusNames[status]}>
      <PendingIcon />
    </div>
  )
}

export default HotelStatusIcon
